import { DependencyList, useCallback, useState } from 'react';

export const useAsyncCallback = <TCallback extends (...args: any) => Promise<any>>(
    callback: TCallback,
    deps: DependencyList,
    opts?: {
        onBefore?: () => void;
        onAfter?: () => void;
    }
) => {
    const [isPending, setIsPending] = useState(false);
    const [error, setError] = useState<any>(null);

    const callbackWrapper = useCallback(
        (async (...args: Parameters<TCallback>) => {
            if (isPending) return;

            setIsPending(true);
            setError(undefined);
            opts?.onBefore?.();
            const result = callback(...args);
            return result
                .catch((err) => {
                    setError(err);
                    return err;
                })
                .finally(() => {
                    setIsPending(false);
                    opts?.onAfter?.();
                });
        }) as TCallback,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [...deps]
    );

    const clear = useCallback(() => {
        setIsPending(false);
        setError(null);
    }, []);

    return {
        isPending,
        error,
        callback: callbackWrapper,
        clear
    };
};
